"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.for-each");

var _axios = _interopRequireDefault(require("axios"));

var _themeCurrency = require("@shopify/theme-currency");

var cart = _interopRequireWildcard(require("@shopify/theme-cart"));

var _utils = require("../helpers/utils");

var _cssClasses = _interopRequireDefault(require("../helpers/cssClasses"));

var _svgMap = require("../helpers/svg-map");

var _quantitySelector = _interopRequireDefault(require("./quantity-selector"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * DOM selectors.
 */


var selectors = {
  container: '[js-cart-table="container"]',
  subtotal: '[js-cart-table="subtotal"]',
  totalDiscount: '[js-cart-table="totalDiscount"]',
  quantitySelector: '[js-cart-table="quantitySelector"]',
  lineItem: '[js-ajax-cart="lineItem"]',
  remove: '[js-cart-table="remove"]',
  cartCounter: '[js-ajax-cart="cartCounter"]'
};
/**
 * Create new cart table object.
 */

var _default = function _default(selector) {
  /**
   * DOM node selectors.
   */
  var nodeSelectors = {
    container: document.querySelector(selector),
    subtotal: document.querySelectorAll(selectors.subtotal),
    totalDiscount: document.querySelector(selectors.totalDiscount),
    cartCounter: document.querySelector(selectors.cartCounter)
  };
  var initialLineItems = document.querySelectorAll(selectors.lineItem);
  /**
   * Instance globals.
   */

  var timer = {};
  /**
   * Initialise component.
   */

  function init() {
    pageLoadingState();
    (0, _utils.queryCart)().then(function (data) {
      render(data);
      initCountdown();
      finishedLoading();
      return data;
    })["catch"](function (error) {
      return error;
    });
  }
  /**
   * Page loading state.
  */


  function pageLoadingState() {
    var container = nodeSelectors.container;

    if (container === null) {
      return;
    }

    container.classList.add(_cssClasses["default"].loading);
  }

  function finishedLoading() {
    nodeSelectors.container.classList.remove(_cssClasses["default"].loading);
  }

  function renderCartCounter(response) {
    nodeSelectors.cartCounter.classList.remove(_cssClasses["default"].hidden);
    nodeSelectors.cartCounter.innerText = response.item_count;

    if (response.item_count <= 0) {
      nodeSelectors.cartCounter.classList.add(_cssClasses["default"].hidden);
    }
  }

  function initCountdown() {
    _toConsumableArray(initialLineItems).forEach(function (item) {
      var bookType = item.attributes['js-product-book-type'].value;
      getProductTags(item.attributes['js-product-handle'].value, bookType, item);
    });
  }
  /**
   * Render cart template.
   */


  function render(data) {
    pageLoadingState();
    nodeSelectors.container.innerHTML = getCartTemplate(data);
    constructQuantitySelectors();
    updateTotal(data);
    Frame.EventBus.emit('AjaxCart:reinit');
  }
  /**
  * ReRender cart template.
  */


  function reRender() {
    (0, _utils.queryCart)().then(function (data) {
      pageLoadingState();
      nodeSelectors.container.innerHTML = getCartTemplate(data);
      renderCartCounter(data);
      constructQuantitySelectors();
      updateTotal(data);
      Frame.EventBus.emit('AjaxCart:reinit');
      initCountdown();
      finishedLoading();
      return data;
    })["catch"](function (error) {
      return error;
    });
  }
  /**
  * Get cart template
  * @param {Object} data - Cart data.
  */


  function getCartTemplate(data) {
    return data.items.map(function (item, index) {
      return getLineItemTemplate(item, index);
    }).join('');
  }
  /**
  * Get line item template.
  * @param {Object} item - Line item data object.
  */


  function setSubscriptionParentUrl(item) {
    return item.properties !== null && item.properties._parent_url !== null ? item.properties._parent_url : item.url;
  }

  function setSubscriptionParentImage(item) {
    return item.properties !== null && item.properties._parent_image_small !== null ? item.properties._parent_image_small : item.image;
  }

  function getLineItemTemplate(item, index) {
    var itemUrl = setSubscriptionParentUrl(item) === undefined ? item.url : setSubscriptionParentUrl(item);
    var itemImage = setSubscriptionParentImage(item) === undefined ? item.image : setSubscriptionParentImage(item);
    var isPodPresent = item.properties._hasPointOfDemand;
    return "\n    <div>\n      <div class=\"cart-table__item ajax-cart__line-item row no-margin no-padding\" js-ajax-cart=\"lineItem\" data-key=\"".concat(item.key, "\" js-product-handle=\"").concat(item.handle, "\">\n        <div class=\"col s4 m3 l2 no-padding cart-table__image ajax-cart__image\" data-label=\"Product\">\n          <a href=\"").concat(itemUrl, "\">\n            <img src=\"").concat(itemImage, "\" alt=\"").concat(item.title, "\">\n          </a>\n        </div>\n\n        <div class=\"row col s8 m9 l10 no-padding no-margin cart-table__description\">\n          <div class=\"col s12 l5 no-padding cart-table__info\">\n            <div js-cart-table=\"countdown\" class=\"cart-ajax__countdown countdown is-disabled\">Preorder - </div>\n            ").concat(getTag(item), "\n\n            <a href=\"").concat(itemUrl, "\" class=\"ajax-cart__title h6\">\n              ").concat(getProductTitle(item), "\n            </a>\n\n            <a\n              class=\"cart-table__remove cart-table__remove-desktop ajax-cart__remove\"\n              href=\"/cart/change?id=").concat(item.key, "&amp;quantity=0\"\n              js-cart-table=\"remove\"\n              data-key=\"").concat(item.key, "\"\n            >\n              ").concat(theme.cart.remove, "\n            </a>\n\n            ").concat(isPodPresent ? "\n              <div class=\"cart-table__pod-message cart-table__pod-message--desktop\">\n                <div class=\"cart-table__pod-message-container\">\n                  <svg class=\"icon icon__print-point-on-demand\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 19 18\">\n                    <mask id=\"a\" width=\"19\" height=\"18\" x=\"0\" y=\"0\" fill=\"#000\" maskUnits=\"userSpaceOnUse\">\n                      <path fill=\"#fff\" d=\"M0 0h19v18H0z\"/>\n                      <path fill-rule=\"evenodd\" d=\"M4.611 4.564H1.879c-.48 0-.879.384-.879.857v7.39c0 .473.399.857.88.857H4.61v3.047c0 .157.129.285.293.285h9.198a.288.288 0 0 0 .293-.285v-3.047h2.726c.486 0 .879-.384.879-.857v-7.39a.868.868 0 0 0-.88-.857h-2.725V1.286A.288.288 0 0 0 14.102 1H4.904a.288.288 0 0 0-.293.286v3.278Zm9.198 5.772v6.093H5.197v-6.093h8.612ZM6.72 15.279h5.563a.288.288 0 0 0 .294-.285.288.288 0 0 0-.293-.286H6.72a.288.288 0 0 0-.293.286c0 .158.13.285.293.285Zm0-1.611h5.563a.288.288 0 0 0 .294-.286.288.288 0 0 0-.293-.285H6.72a.288.288 0 0 0-.293.285c0 .158.13.286.293.286Zm7.674-.571h2.726a.288.288 0 0 0 .293-.286v-7.39a.288.288 0 0 0-.293-.286H1.879a.292.292 0 0 0-.293.286v7.39c0 .158.135.286.293.286h2.732V10.05c0-.158.129-.285.293-.285h9.198c.164 0 .293.127.293.285v3.047Zm-7.674-1.04h5.563a.288.288 0 0 0 .294-.286.288.288 0 0 0-.293-.286H6.72a.288.288 0 0 0-.293.286c0 .157.13.285.293.285Zm7.088-7.493V1.571H5.197v2.993h8.612Z\" clip-rule=\"evenodd\"/>\n                    </mask>\n                    <path fill=\"#000\" fill-rule=\"evenodd\" d=\"M4.611 4.564H1.879c-.48 0-.879.384-.879.857v7.39c0 .473.399.857.88.857H4.61v3.047c0 .157.129.285.293.285h9.198a.288.288 0 0 0 .293-.285v-3.047h2.726c.486 0 .879-.384.879-.857v-7.39a.868.868 0 0 0-.88-.857h-2.725V1.286A.288.288 0 0 0 14.102 1H4.904a.288.288 0 0 0-.293.286v3.278Zm9.198 5.772v6.093H5.197v-6.093h8.612ZM6.72 15.279h5.563a.288.288 0 0 0 .294-.285.288.288 0 0 0-.293-.286H6.72a.288.288 0 0 0-.293.286c0 .158.13.285.293.285Zm0-1.611h5.563a.288.288 0 0 0 .294-.286.288.288 0 0 0-.293-.285H6.72a.288.288 0 0 0-.293.285c0 .158.13.286.293.286Zm7.674-.571h2.726a.288.288 0 0 0 .293-.286v-7.39a.288.288 0 0 0-.293-.286H1.879a.292.292 0 0 0-.293.286v7.39c0 .158.135.286.293.286h2.732V10.05c0-.158.129-.285.293-.285h9.198c.164 0 .293.127.293.285v3.047Zm-7.674-1.04h5.563a.288.288 0 0 0 .294-.286.288.288 0 0 0-.293-.286H6.72a.288.288 0 0 0-.293.286c0 .157.13.285.293.285Zm7.088-7.493V1.571H5.197v2.993h8.612Z\" clip-rule=\"evenodd\"/>\n                    <path fill=\"#000\" d=\"M4.611 4.564v.15h.15v-.15h-.15Zm0 9.104h.15v-.15h-.15v.15Zm9.784 0v-.15h-.15v.15h.15Zm0-9.104h-.15v.15h.15v-.15Zm-.586 5.772h.15v-.15h-.15v.15Zm0 6.093v.15h.15v-.15h-.15Zm-8.612 0h-.15v.15h.15v-.15Zm0-6.093v-.15h-.15v.15h.15Zm9.198 2.76h-.15v.15h.15v-.15Zm-9.784 0v.15h.15v-.15h-.15Zm9.198-8.532v.15h.15v-.15h-.15Zm0-2.993h.15v-.15h-.15v.15Zm-8.612 0v-.15h-.15v.15h.15Zm0 2.993h-.15v.15h.15v-.15Zm-.586-.15H1.879v.3h2.732v-.3Zm-2.732 0C1.32 4.414.85 4.861.85 5.421h.3c0-.386.327-.707.73-.707v-.3ZM.85 5.421v7.39h.3v-7.39h-.3Zm0 7.39c0 .56.47 1.007 1.03 1.007v-.3a.722.722 0 0 1-.73-.707h-.3Zm1.03 1.007H4.61v-.3H1.879v.3Zm2.581-.15v3.047h.3v-3.047h-.3Zm0 3.047c0 .243.199.435.443.435v-.3a.138.138 0 0 1-.143-.136h-.3Zm.443.435h9.198v-.3H4.904v.3Zm9.198 0a.438.438 0 0 0 .443-.435h-.3a.138.138 0 0 1-.143.135v.3Zm.443-.435v-3.047h-.3v3.047h.3Zm-.15-2.897h2.726v-.3h-2.726v.3Zm2.726 0c.566 0 1.029-.447 1.029-1.007h-.3a.718.718 0 0 1-.73.707v.3Zm1.029-1.007v-7.39h-.3v7.39h.3Zm0-7.39c0-.56-.463-1.007-1.03-1.007v.3c.408 0 .73.32.73.707h.3Zm-1.03-1.007h-2.725v.3h2.726v-.3Zm-2.575.15V1.286h-.3v3.278h.3Zm0-3.278c0-.244-.2-.436-.443-.436v.3c.084 0 .143.064.143.136h.3ZM14.102.85H4.904v.3h9.198v-.3Zm-9.198 0a.438.438 0 0 0-.443.436h.3c0-.072.059-.136.143-.136v-.3Zm-.443.436v3.278h.3V1.286h-.3Zm9.198 9.05v6.093h.3v-6.093h-.3Zm.15 5.943H5.197v.3h8.612v-.3Zm-8.462.15v-6.093h-.3v6.093h.3Zm-.15-5.943h8.612v-.3H5.197v.3Zm1.524 4.943h5.563v-.3H6.721v.3Zm5.563 0a.438.438 0 0 0 .444-.435h-.3a.138.138 0 0 1-.144.135v.3Zm.444-.435c0-.243-.2-.436-.444-.436v.3c.085 0 .144.064.144.136h.3Zm-.444-.436H6.721v.3h5.563v-.3Zm-5.563 0a.438.438 0 0 0-.443.436h.3c0-.072.06-.136.143-.136v-.3Zm-.443.436c0 .243.2.435.443.435v-.3a.138.138 0 0 1-.143-.135h-.3Zm.443-1.176h5.563v-.3H6.721v.3Zm5.563 0a.438.438 0 0 0 .444-.436h-.3a.138.138 0 0 1-.144.136v.3Zm.444-.436c0-.243-.2-.435-.444-.435v.3c.085 0 .144.063.144.135h.3Zm-.444-.435H6.721v.3h5.563v-.3Zm-5.563 0a.438.438 0 0 0-.443.435h.3c0-.072.06-.135.143-.135v-.3Zm-.443.435c0 .244.2.436.443.436v-.3a.138.138 0 0 1-.143-.136h-.3Zm8.117-.135h2.726v-.3h-2.726v.3Zm2.726 0a.438.438 0 0 0 .443-.436h-.3a.138.138 0 0 1-.143.136v.3Zm.443-.436v-7.39h-.3v7.39h.3Zm0-7.39c0-.244-.2-.436-.443-.436v.3c.084 0 .143.064.143.136h.3Zm-.443-.436H1.879v.3h15.242v-.3Zm-15.242 0a.442.442 0 0 0-.443.436h.3c0-.07.063-.136.143-.136v-.3Zm-.443.436v7.39h.3v-7.39h-.3Zm0 7.39c0 .245.207.436.443.436v-.3a.142.142 0 0 1-.143-.136h-.3Zm.443.436h2.732v-.3H1.879v.3Zm2.882-.15V10.05h-.3v3.047h.3Zm0-3.047c0-.072.059-.135.143-.135v-.3a.438.438 0 0 0-.443.435h.3Zm.143-.135h9.198v-.3H4.904v.3Zm9.198 0c.084 0 .143.063.143.135h.3c0-.244-.2-.435-.443-.435v.3Zm.143.135v3.047h.3V10.05h-.3ZM6.72 12.206h5.563v-.3H6.721v.3Zm5.563 0a.438.438 0 0 0 .444-.435h-.3a.138.138 0 0 1-.144.135v.3Zm.444-.435c0-.244-.2-.436-.444-.436v.3c.085 0 .144.064.144.136h.3Zm-.444-.436H6.721v.3h5.563v-.3Zm-5.563 0a.438.438 0 0 0-.443.436h.3c0-.072.06-.136.143-.136v-.3Zm-.443.436c0 .243.2.435.443.435v-.3a.138.138 0 0 1-.143-.135h-.3Zm7.68-7.207V1.571h-.3v2.993h.3Zm-.15-3.143h-8.61v.3h8.61v-.3Zm-8.76.15v2.993h.3V1.571h-.3Zm.15 3.143h8.61v-.3h-8.61v.3Z\" mask=\"url(#a)\"/>\n                  </svg>\n\n                  <span>".concat(theme.strings.printOnDemand, "</span>\n                </div>\n              </div>\n            ") : '', "\n\n            ").concat(alreadyPurchasedAlert(item, 'desktop'), "\n          </div>\n\n          <div class=\"row col s12 l7 no-padding no-margin cart-table__price-info\">\n            <p class=\"col s12 l4 no-padding cart-table__price cart-table__price-desktop h6\">\n              ").concat(getSubtotalItemPrice(item), "\n              ").concat(getOriginalLineItemPrice(item), "\n            </p>\n            <div class=\"col s12 l4 no-padding cart-table__quantity-selector\" data-label=\"Quantity\">\n              ").concat(setQuantitySelector(item, index), "\n            </div>\n            <p class=\"col s12 l4 no-padding cart-table__price h6\">\n              ").concat(getSubtotalItemPrice(item), "\n              ").concat(getOriginalLineItemPrice(item), "\n            </p>\n          </div>\n\n          <a \n            class=\"cart-table__remove ajax-cart__remove\" \n            href=\"/cart/change?id=").concat(item.key, "&amp;quantity=0\" \n            data-key=\"").concat(item.key, "\"\n            js-cart-table=\"remove\" \n          >\n            ").concat(theme.cart.remove, "\n          </a>\n        </div>\n\n        ").concat(isPodPresent ? "\n          <div class=\"cart-table__pod-message cart-table__pod-message--mobile\">\n            <div class=\"cart-table__pod-message-container\">\n              <svg class=\"icon icon__print-point-on-demand\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 19 18\">\n                <mask id=\"a\" width=\"19\" height=\"18\" x=\"0\" y=\"0\" fill=\"#000\" maskUnits=\"userSpaceOnUse\">\n                  <path fill=\"#fff\" d=\"M0 0h19v18H0z\"/>\n                  <path fill-rule=\"evenodd\" d=\"M4.611 4.564H1.879c-.48 0-.879.384-.879.857v7.39c0 .473.399.857.88.857H4.61v3.047c0 .157.129.285.293.285h9.198a.288.288 0 0 0 .293-.285v-3.047h2.726c.486 0 .879-.384.879-.857v-7.39a.868.868 0 0 0-.88-.857h-2.725V1.286A.288.288 0 0 0 14.102 1H4.904a.288.288 0 0 0-.293.286v3.278Zm9.198 5.772v6.093H5.197v-6.093h8.612ZM6.72 15.279h5.563a.288.288 0 0 0 .294-.285.288.288 0 0 0-.293-.286H6.72a.288.288 0 0 0-.293.286c0 .158.13.285.293.285Zm0-1.611h5.563a.288.288 0 0 0 .294-.286.288.288 0 0 0-.293-.285H6.72a.288.288 0 0 0-.293.285c0 .158.13.286.293.286Zm7.674-.571h2.726a.288.288 0 0 0 .293-.286v-7.39a.288.288 0 0 0-.293-.286H1.879a.292.292 0 0 0-.293.286v7.39c0 .158.135.286.293.286h2.732V10.05c0-.158.129-.285.293-.285h9.198c.164 0 .293.127.293.285v3.047Zm-7.674-1.04h5.563a.288.288 0 0 0 .294-.286.288.288 0 0 0-.293-.286H6.72a.288.288 0 0 0-.293.286c0 .157.13.285.293.285Zm7.088-7.493V1.571H5.197v2.993h8.612Z\" clip-rule=\"evenodd\"/>\n                </mask>\n                <path fill=\"#000\" fill-rule=\"evenodd\" d=\"M4.611 4.564H1.879c-.48 0-.879.384-.879.857v7.39c0 .473.399.857.88.857H4.61v3.047c0 .157.129.285.293.285h9.198a.288.288 0 0 0 .293-.285v-3.047h2.726c.486 0 .879-.384.879-.857v-7.39a.868.868 0 0 0-.88-.857h-2.725V1.286A.288.288 0 0 0 14.102 1H4.904a.288.288 0 0 0-.293.286v3.278Zm9.198 5.772v6.093H5.197v-6.093h8.612ZM6.72 15.279h5.563a.288.288 0 0 0 .294-.285.288.288 0 0 0-.293-.286H6.72a.288.288 0 0 0-.293.286c0 .158.13.285.293.285Zm0-1.611h5.563a.288.288 0 0 0 .294-.286.288.288 0 0 0-.293-.285H6.72a.288.288 0 0 0-.293.285c0 .158.13.286.293.286Zm7.674-.571h2.726a.288.288 0 0 0 .293-.286v-7.39a.288.288 0 0 0-.293-.286H1.879a.292.292 0 0 0-.293.286v7.39c0 .158.135.286.293.286h2.732V10.05c0-.158.129-.285.293-.285h9.198c.164 0 .293.127.293.285v3.047Zm-7.674-1.04h5.563a.288.288 0 0 0 .294-.286.288.288 0 0 0-.293-.286H6.72a.288.288 0 0 0-.293.286c0 .157.13.285.293.285Zm7.088-7.493V1.571H5.197v2.993h8.612Z\" clip-rule=\"evenodd\"/>\n                <path fill=\"#000\" d=\"M4.611 4.564v.15h.15v-.15h-.15Zm0 9.104h.15v-.15h-.15v.15Zm9.784 0v-.15h-.15v.15h.15Zm0-9.104h-.15v.15h.15v-.15Zm-.586 5.772h.15v-.15h-.15v.15Zm0 6.093v.15h.15v-.15h-.15Zm-8.612 0h-.15v.15h.15v-.15Zm0-6.093v-.15h-.15v.15h.15Zm9.198 2.76h-.15v.15h.15v-.15Zm-9.784 0v.15h.15v-.15h-.15Zm9.198-8.532v.15h.15v-.15h-.15Zm0-2.993h.15v-.15h-.15v.15Zm-8.612 0v-.15h-.15v.15h.15Zm0 2.993h-.15v.15h.15v-.15Zm-.586-.15H1.879v.3h2.732v-.3Zm-2.732 0C1.32 4.414.85 4.861.85 5.421h.3c0-.386.327-.707.73-.707v-.3ZM.85 5.421v7.39h.3v-7.39h-.3Zm0 7.39c0 .56.47 1.007 1.03 1.007v-.3a.722.722 0 0 1-.73-.707h-.3Zm1.03 1.007H4.61v-.3H1.879v.3Zm2.581-.15v3.047h.3v-3.047h-.3Zm0 3.047c0 .243.199.435.443.435v-.3a.138.138 0 0 1-.143-.136h-.3Zm.443.435h9.198v-.3H4.904v.3Zm9.198 0a.438.438 0 0 0 .443-.435h-.3a.138.138 0 0 1-.143.135v.3Zm.443-.435v-3.047h-.3v3.047h.3Zm-.15-2.897h2.726v-.3h-2.726v.3Zm2.726 0c.566 0 1.029-.447 1.029-1.007h-.3a.718.718 0 0 1-.73.707v.3Zm1.029-1.007v-7.39h-.3v7.39h.3Zm0-7.39c0-.56-.463-1.007-1.03-1.007v.3c.408 0 .73.32.73.707h.3Zm-1.03-1.007h-2.725v.3h2.726v-.3Zm-2.575.15V1.286h-.3v3.278h.3Zm0-3.278c0-.244-.2-.436-.443-.436v.3c.084 0 .143.064.143.136h.3ZM14.102.85H4.904v.3h9.198v-.3Zm-9.198 0a.438.438 0 0 0-.443.436h.3c0-.072.059-.136.143-.136v-.3Zm-.443.436v3.278h.3V1.286h-.3Zm9.198 9.05v6.093h.3v-6.093h-.3Zm.15 5.943H5.197v.3h8.612v-.3Zm-8.462.15v-6.093h-.3v6.093h.3Zm-.15-5.943h8.612v-.3H5.197v.3Zm1.524 4.943h5.563v-.3H6.721v.3Zm5.563 0a.438.438 0 0 0 .444-.435h-.3a.138.138 0 0 1-.144.135v.3Zm.444-.435c0-.243-.2-.436-.444-.436v.3c.085 0 .144.064.144.136h.3Zm-.444-.436H6.721v.3h5.563v-.3Zm-5.563 0a.438.438 0 0 0-.443.436h.3c0-.072.06-.136.143-.136v-.3Zm-.443.436c0 .243.2.435.443.435v-.3a.138.138 0 0 1-.143-.135h-.3Zm.443-1.176h5.563v-.3H6.721v.3Zm5.563 0a.438.438 0 0 0 .444-.436h-.3a.138.138 0 0 1-.144.136v.3Zm.444-.436c0-.243-.2-.435-.444-.435v.3c.085 0 .144.063.144.135h.3Zm-.444-.435H6.721v.3h5.563v-.3Zm-5.563 0a.438.438 0 0 0-.443.435h.3c0-.072.06-.135.143-.135v-.3Zm-.443.435c0 .244.2.436.443.436v-.3a.138.138 0 0 1-.143-.136h-.3Zm8.117-.135h2.726v-.3h-2.726v.3Zm2.726 0a.438.438 0 0 0 .443-.436h-.3a.138.138 0 0 1-.143.136v.3Zm.443-.436v-7.39h-.3v7.39h.3Zm0-7.39c0-.244-.2-.436-.443-.436v.3c.084 0 .143.064.143.136h.3Zm-.443-.436H1.879v.3h15.242v-.3Zm-15.242 0a.442.442 0 0 0-.443.436h.3c0-.07.063-.136.143-.136v-.3Zm-.443.436v7.39h.3v-7.39h-.3Zm0 7.39c0 .245.207.436.443.436v-.3a.142.142 0 0 1-.143-.136h-.3Zm.443.436h2.732v-.3H1.879v.3Zm2.882-.15V10.05h-.3v3.047h.3Zm0-3.047c0-.072.059-.135.143-.135v-.3a.438.438 0 0 0-.443.435h.3Zm.143-.135h9.198v-.3H4.904v.3Zm9.198 0c.084 0 .143.063.143.135h.3c0-.244-.2-.435-.443-.435v.3Zm.143.135v3.047h.3V10.05h-.3ZM6.72 12.206h5.563v-.3H6.721v.3Zm5.563 0a.438.438 0 0 0 .444-.435h-.3a.138.138 0 0 1-.144.135v.3Zm.444-.435c0-.244-.2-.436-.444-.436v.3c.085 0 .144.064.144.136h.3Zm-.444-.436H6.721v.3h5.563v-.3Zm-5.563 0a.438.438 0 0 0-.443.436h.3c0-.072.06-.136.143-.136v-.3Zm-.443.436c0 .243.2.435.443.435v-.3a.138.138 0 0 1-.143-.135h-.3Zm7.68-7.207V1.571h-.3v2.993h.3Zm-.15-3.143h-8.61v.3h8.61v-.3Zm-8.76.15v2.993h.3V1.571h-.3Zm.15 3.143h8.61v-.3h-8.61v.3Z\" mask=\"url(#a)\"/>\n              </svg>\n\n              <span>".concat(theme.strings.printOnDemand, "</span>\n            </div>\n          </div>\n        ") : '', "\n  \n        ").concat(alreadyPurchasedAlert(item, 'mobile'), "\n      </div>\n    </div>\n    ");
  }
  /**
   * Get product title.
   * @param {object} item - Line item data object.
   * @returns {string}
   */


  function getProductTitle(item) {
    if (item.properties && item.properties.prepaid_subscription === 'true') {
      return "".concat(item.product_title, " - ").concat(theme.strings.cart.label.prepaidSubscription);
    }

    return item.product_title;
  }
  /**
   * Renders quantity selector on the cart line item.
   * @param {Object} item - Cart line item.
   * @param {Number} index - Cart line item index.
   */


  function setQuantitySelector(item, index) {
    var sanitisedVariantTitle = '';

    if (item.variant_title !== null) {
      sanitisedVariantTitle = item.variant_title.toLowerCase();
    }

    if (sanitisedVariantTitle === 'ebook') {
      return "\n        <div class=\"cart-table__quantity-container\">\n          <span>".concat(item.quantity, "</span>\n        </div>\n      ");
    }

    return "\n    <label for=\"Quantity-".concat(index, "\" class=\"label\">Quantity</label>\n      <div id=\"QuantitySelector-").concat(index, "\" class=\"quantity-selector\" js-cart-table=\"quantitySelector\">\n        <div class=\"quantity-selector__control\">\n          <button class=\"button quantity-selector__button\" js-quantity-selector=\"decrement\" value=\"decrement\">\n            ").concat(_svgMap.misc.minus, "\n            <span class=\"visually-hidden\">-</span>\n          </button>\n        </div>\n\n        <div class=\"quantity-selector__control\">\n          <input type=\"number\" id=\"Quantity-").concat(index, "\" name=\"quantity\" value=\"").concat(item.quantity, "\" min=\"0\" pattern=\"[0-9]*\" class=\"quantity-selector__input\" js-quantity-selector=\"input\" readonly />\n        </div>\n\n        <div class=\"quantity-selector__control\">\n          <button class=\"button quantity-selector__button\" js-quantity-selector=\"increment\" value=\"increment\">\n            ").concat(_svgMap.misc.plus, "\n            <span class=\"visually-hidden\">+</span>\n          </button>\n        </div>\n      </div>");
  }
  /**
   * Get Line Item Product Tags.
   * @param handle - Line item product handle.
   */


  function getProductTags(handle, bookType, item) {
    _axios["default"].get("/products/".concat(handle, ".js")).then(function (response) {
      findPubData(response.data.tags, bookType, item);
      return response;
    })["catch"](function (error) {
      window.console.error(error);
      return error;
    });
  }
  /**
   * Get publication data from tags.
   * @param productTags - Line item product tags.
   */


  function findPubData(tags, bookType, item) {
    var filteredTags = tags.filter(function (tag) {
      return tag.includes('pubdate');
    });
    renderCountDown(filteredTags, bookType, item);
  }
  /**
  * Render filtered countdown based on tags.
  * @param filteredTags - filtered line item tags.
  */


  function renderCountDown(filteredTags, bookType, item) {
    var tagWithBookType = filteredTags.filter(function (tag) {
      return tag.includes(bookType.toLowerCase());
    });
    var countDownDate = tagWithBookType.shift().split('-').slice(1).join('-');
    var releaseDate = new Date(countDownDate.replace(/(\d{2})-(\d{2})-(\d{4})/, '$2/$1/$3'));
    var currentDate = new Date().getTime();
    var distance = releaseDate - currentDate;
    var daysLeft = Math.floor(distance / (1000 * 60 * 60 * 24));
    var countdownText;

    if (daysLeft === 1) {
      countdownText = theme.strings.countdownTextOne.replace('[days]', daysLeft);
    } else if (daysLeft === 0) {
      countdownText = theme.strings.countdownTextOne.replace('[days]', '1');
    } else {
      countdownText = theme.strings.countdownTextMany.replace('[days]', daysLeft);
    }

    var newLineItem = document.querySelector("[js-product-handle=\"".concat(item.attributes['js-product-handle'].value, "\"]"));

    if (newLineItem === null) {
      return;
    }

    var countdownEl = newLineItem.querySelector('[js-cart-table="countdown"]');

    if (distance > 0) {
      countdownEl.classList.remove('is-disabled');
      countdownEl.innerHTML = "Preorder - ".concat(countdownText);
    } else {
      countdownEl.style.display = 'none';
    }
  }
  /**
   * Get tag.
   * @param {object} item - Line item data object.
   */


  function getTag(item) {
    var hasLoyaltyDiscountTag = item.tags.find(function (tag) {
      return tag.startsWith('manual-loyalty:');
    });

    if (theme.loyalty.loyaltyDiscountEnable && theme.isLoyaltyCustomer && hasLoyaltyDiscountTag && item.properties._compare_at_price === '') {
      return "\n        <span class=\"ajax-cart__tag h6\">\n          ".concat(window.theme.strings.collections.general.loyaltyBadgeTitle, "\n        </span>\n      ");
    } else if (item.discounts.length > 0) {
      return "<span class=\"ajax-cart__tag h6\">".concat(item.discounts[0].title, "</span>");
    } else {
      return '';
    }
  }
  /**
   * Get variant titles.
   * @param {Object} item - Line item data object.
   * @returns {string} - Variant title string.
   */


  function getVariantTitle(item) {
    return item.variant_options.length && !item.variant_options[0].includes('Default Title') ? "<p class=\"meta h6\">".concat(item.variant_title, "</p>") : '';
  }
  /**
   * Get formatted subtotal item price.
   * @param {Object} item - Line item data object.
   * @returns {string} - Formatted price string.
   */


  function getSubtotalItemPrice(item) {
    return "".concat((0, _themeCurrency.formatMoney)(item.line_price, theme.moneyFormat));
  }
  /**
   * Get formatted original line item price.
   * @param {Object} item - Line item data object.
   * @returns {string} -  Formatted price string.
   */


  function getOriginalLineItemPrice(item) {
    if (item.properties._compare_at_price !== '') {
      return "\n        <span class=\"ajax-cart__price--original\">\n          <s>".concat((0, _themeCurrency.formatMoney)(item.properties._compare_at_price * item.quantity, theme.moneyFormat), "</s>\n        </span>\n      ");
    } else if (item.discounts.length > 0) {
      return "<span class=\"ajax-cart__price--original\"><s>".concat((0, _themeCurrency.formatMoney)(item.original_line_price, theme.moneyFormat), "</s></span>");
    } else {
      return '';
    }
  }
  /**
   * Instantiate quantity selectors using id.
   * - Callback has a timer to reduce number of calls.
   */


  function constructQuantitySelectors() {
    var quantitySelectors = document.querySelectorAll(selectors.quantitySelector);
    /**
     * Instance default settings.
     */

    var config = {
      minDecreaseValue: 0
    };

    _toConsumableArray(quantitySelectors).forEach(function (item) {
      (0, _quantitySelector["default"])("".concat(item.id), config, function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          handleQuantityEvent(item);
        }, 250);
      }).init();
    });
  }
  /**
   * Handle quantity updates.
   * @param {HTMLElement} element - Quantity selector node element.
   */


  function handleQuantityEvent(element) {
    var data = {
      key: element.closest(selectors.lineItem).dataset.key,
      quantity: parseInt(element.querySelector('input').value, 10)
    };
    cart.updateItem(data.key, {
      quantity: data.quantity
    }).then(function (response) {
      Frame.EventBus.emit('AjaxCart:quantityUpdated');
      reRender();
      updateTotal(response);
      return response;
    })["catch"](function (error) {
      window.console.error(error);
      return error;
    });
  }
  /**
   * removeProduct
   */


  function removeProduct(element) {
    var data = {
      key: element.closest(selectors.lineItem).dataset.key
    };
    Frame.EventBus.emit('AjaxCart:removingItem', element.closest(selectors.lineItem));
    cart.updateItem(data.key, {
      quantity: 0
    }).then(function (response) {
      Frame.EventBus.emit('AjaxCart:cartItemRemoved');
      reRender();
      return response;
    })["catch"](function (error) {
      window.console.error(error);
      return error;
    });
  }
  /**
   * Update subtotal and discount total.
   * @param {Object} data - Cart response data.
   */


  function updateTotal(data) {
    updateSubtotal(data.total_price);
  }
  /**
  * Update subtotal.
  * @param {Number} price - Total cart price number.
  */


  function updateSubtotal(price) {
    _toConsumableArray(nodeSelectors.subtotal).forEach(function (element) {
      element.innerHTML = (0, _themeCurrency.formatMoney)(price, theme.moneyFormat);
    });
  }
  /**
   * Shows alert if ebook has been purchased in the past.
   * @param {Object} item - Cart line item object data.
   * @param {String} style - If desktop or mobile design.
   * @returns {string} - Ebook already purchased alert.
   */


  function alreadyPurchasedAlert(item, style) {
    return window.orderedBooks && window.orderedBooks.includes(item.variant_id.toString()) ? "<p class=\"\n          ebook-alert\n          ebook-alert--cart\n          ebook-alert--cart-".concat(style, "\n        \">\n          ").concat(theme.strings.ebooks.ebookAlertCart, "\n        </p>") : '';
  }

  return Object.freeze({
    init: init
  });
};

exports["default"] = _default;